<template>
  <div id="webApp" class="webApp">
    <om-audio />
    <router-view class="k-page" />
  </div>
</template>
<script>
  export default {

  }
</script>
